/** Compartilhadas pela página e pelo FAQPage dos dados estruturados. */
export interface Duvida {
  pergunta: string;
  resposta: string;
}

export const DUVIDAS: Duvida[] = [
  {
    pergunta: 'Como começo a estudar na Titularis?',
    resposta:
      'Crie sua conta gratuita, escolha o módulo Enac e comece a resolver questões. Você pode filtrar por disciplina e assunto e ler os comentários das alternativas para entender o raciocínio de cada resposta.',
  },
  {
    pergunta: 'Preciso de cartão para criar uma conta?',
    resposta:
      'Não. A conta gratuita libera uma cota semanal de questões e resoluções comentadas, renovada toda segunda-feira, à meia-noite de Brasília. Você conhece a experiência sem informar um cartão.',
  },
  {
    pergunta: 'Quais conteúdos já estão disponíveis?',
    resposta:
      'O Enac e a 1ª fase dos concursos estaduais já estão disponíveis, com questões comentadas alternativa por alternativa, e são vendidos separadamente. O Enac inclui a Legislação Comentada. O módulo da 2ª fase está em preparação, e você pode entrar na lista para receber o aviso de lançamento.',
  },
  {
    pergunta: 'Como os comentários são revisados?',
    resposta:
      'O conteúdo é revisado por profissionais qualificados, e as citações de lei são conferidas com o texto oficial antes da publicação. Se encontrar uma inconsistência, você pode reportá-la diretamente na questão.',
  },
  {
    pergunta: 'Posso estudar pelo celular?',
    resposta:
      'Sim. A Titularis funciona no navegador do celular, do tablet e do computador. Não é preciso instalar nada.',
  },
];
